import { connect } from 'react-redux'

function mapStateToProps (state, props) {
  return {
    photoFiles: state.uploader?.[props.uploaderOptions.buttonId]?.files || {}
  }
}

function mapDispatchToProps (dispatch) {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)
